// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ae01582","337":"3dd5ab27","455":"cff088f3"}[chunkId] + ".chunk.js";
};